// extracted by mini-css-extract-plugin
module.exports = {"main__container":"table_main__container___9tI3","contents__table":"table_contents__table__lPUxj","content__item":"table_content__item__FZibO"};